export default __webpack_public_path__ + "static/media/copy.6f139c45.svg";